<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <i class="fa fa-align-justify"></i> Surveys
                  <button type="button" class="btn btn-outline-primary pull-right" @click="addSurvey"><i class="fa fa-plus"></i>&nbsp; Add Survey</button>
              </div>
              <div class="card-block">
                <table class="table table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Date Created</th>
                      <th>Created By</th>
                      <th>Test Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="item in surveyList">
                      <tr>
                        <td>{{item.surveyName}}</td>
                        <td>{{formatDate(item.idt)}}</td>
                        <td>{{item.firstName}} {{item.lastName}}</td>
                        <td><a :href="'../pdf/reports/vtm/costsavings/' + item.userSurveyID + '/'" target="_blank">Link</a></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <nav>
                  <ul class="pagination">
                    <li class="page-item"><a class="page-link" href="#">Prev</a></li>
                    <li class="page-item active">
                      <a class="page-link" href="#">1</a>
                    </li>
                    <li class="page-item"><a class="page-link" href="#">2</a></li>
                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                    <li class="page-item"><a class="page-link" href="#">4</a></li>
                    <li class="page-item"><a class="page-link" href="#">Next</a></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div><!--/.col-->
        </b-row><!--/.row-->
      </div><!--animated-fadein -->
    </div><!--wrapper-->
</template>

<script>
import { tokenMixin } from '@/mixins/tokenMixin'
//import modal from 'bootstrap-vue'

export default {
  name: 'AdminCompletedSurveys',
  mixins: [tokenMixin],
  components: {
    //modal
  },
  data () {
    return {
      surveyList: [],
      myModal: false,
      element: '',
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: ''
      },
      uploadFormData: {
        surveyName: '',
        uploadFile: []

      }
    }
  },
  methods: {
    handleFileUpload (name, file) {
      this.uploadFormData.uploadFile = file;
    },
    addSurvey (e) {
      e.preventDefault();
      this.myModal = true;
    },
    formatDate (dateIn) {
      if (dateIn === null || dateIn === '0001-01-01T00:00:00')
      {
        return ''
      }
      else {
        var dateOut = new Date(dateIn);
        return dateOut.toLocaleDateString();
      }
    },
    loadSurveyList () {
      console.log('get surveys')
      if (this.checkForToken())
      {
        this.axios.get(process.env.VUE_APP_API_BASE + 'admin/surveymanager/getcompletedsurveys', this.buildTokenHeader()).then(response => {
          return response
        })
        .then(res => {
          if (res.status === 200)
          {
            this.surveyList = res.data;
            console.log(res.data);
          }
        })
        .catch(error => {
          console.log(error.response)
        });
      }
    }
  },
  mounted: function () {
    this.loadSurveyList();
  }
}
</script>
